export default "__VITE_ASSET__NviDCHFR__"